import { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { resendVerificationApi } from "../model/authApi";
import { toastService } from "@/shared/toast";
import { routes } from "@/app/navigation/routes";

export const useEmailVerificationRequiredViewModel = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state || {}) as { email?: string };
  const [email, setEmail] = useState(state.email || "");

  const BUTTON_ID = "resend-verification-button";

  const mutation = useMutation({
    mutationFn: (emailToUse: string) => resendVerificationApi(emailToUse, "inline", BUTTON_ID),

    onSuccess: () => {
      toastService.show("Verification email has been resent. Please check your inbox.", "success");
    },

    onError: () => {
      toastService.show("Failed to resend verification email. Please try again.", "error");
    },
  });

  const updateEmail = useCallback((value: string) => {
    setEmail(value);
  }, []);

  const handleResend = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!email) {
        toastService.show("Email is required", "error");
        return;
      }

      mutation.mutate(email);
    },
    [email, mutation]
  );

  const goToLogin = useCallback(() => {
    navigate(routes.login);
  }, [navigate]);

  return {
    email,
    updateEmail,
    handleResend,
    goToLogin,
    isLoading: mutation.isPending,
  };
};
